import React, { useState } from "react";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";
import {Image} from "@arctheme-components/elements/Image/Image";
import {FindInStore} from "@project-stories/client/FindInStore/FindInStore";
import FitSlider from "../FitSlider/FitSlider";

export const ProductAccordion = ({ settings, items, show_header }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const { block_settings, product_tags } = settings;


  const isFinalSale = product_tags.some(tag => tag.toLowerCase() === 'finalsale');

  const onTitleClick = (item, index) => {
    setActiveIndex(index === activeIndex ? null : index);

    if (item.title == 'GARMENT MEASUREMENTS'){
      // Trigger click on the element with id 'kiwi-size-guide'
      const sizeGuideElement = document.getElementById("kiwi-size-guide");
      if (sizeGuideElement) {
        sizeGuideElement.click();
      }
    }
  };

  // Filter items to only include those with a title and content
  const filteredItems = items.filter((dataitem) => dataitem.title);

  const allowed_titles = [
    'IN STORE AVAILABILITY',
      // 'CARE'
  ]

  return (
    <div className="accordion">

      {filteredItems.map((item, index) => (
        <React.Fragment key={index}>
          {(item.content || allowed_titles.includes(item.title) ||
                  item.title == 'CARE' && settings.metafield_care ||
                  item.title == 'FIT' && settings.metafield_fit
              ) &&
            <div className="py-2 lg:py-3 cursor-pointer">
              <div
                className="accordion__header"
                onClick={() => onTitleClick(item, index)}
              >
                <span className="accordion__image-container">
                  {/* <div className="accordion__image">
                    {item.icon && <Image imageUrl={item.icon} width={block_settings.icon_sizes}/>}
                  </div> */}
                  <div className="accordion__title h5">{item.title}</div>
                </span>
                <span className="accordion__toggle">
                  <i
                    className={`icon text-[${block_settings.icon_sizes}px] ${activeIndex === index ? "icon-minus" : "icon-plus"}`}
                  ></i>
                </span>
              </div>
              <div
                  className={`accordion-content font-light ${activeIndex === index ? "active" : ""}`}
                  style={{
                    maxHeight: activeIndex === index ? "1000px" : "0",
                  }}
              >
                <div className={"accordion-content__wrapper"}>
                  <Paragraph text={item.content} type={"b2"} maxChars={1000}/>
                  {item.title == 'IN STORE AVAILABILITY' && <FindInStore/>}
                  {item.title == 'CARE' && <Paragraph text={settings.metafield_care} type={"b4"} maxChars={1000}/>}
                  {item.title == 'FIT' &&
                      <>
                        <Paragraph text={settings.metafield_fit} type={"b4"} maxChars={1000}/>
                        {settings.metafield_fitscale &&
                            <FitSlider fit={settings.metafield_fitscale}/>
                        }
                      </>
                  }
                </div>
                {isFinalSale && item.title == 'DESCRIPTION' && <div className={`text-[#d73f44] text-[12px] font-light mt-2`}>
                  This item is final sale and cannot be returned.
                </div>}
              </div>


            </div>
          }
        </React.Fragment>
      ))}
    </div>
  );
};

export default ProductAccordion;
